// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AsyncProfilePicture_wrapper__gwkLG","roundedTop":"AsyncProfilePicture_roundedTop__qPjI2"};